const inRange = function (num, start, end) {
  if (!end) {
    end = start
    start = 0
  }
  return num >= start && num <= end
}

export {
  inRange
}



// WEBPACK FOOTER //
// ./src/plugins/numberhelper.js